<template>
  <div class="navbar-container d-flex content align-items-center">

    <div class="loading_page" v-if="spinner">
      <orbit-spinner
          :animation-duration="1000"
          :size="30"
          :color="'#0e96b1'"
      />
    </div>

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">

      <!-- Bookmarks Container -->
      <bookmarks />
    </div>
    
    <b-navbar-nav class="nav align-items-center ml-auto">
      <date-time-widget/>
      <locale :spinner.sync="spinner" />
      <dark-toggler class="d-none d-lg-block" :spinner.sync="spinner" />
      <notification-dropdown />
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import  DateTimeWidget   from '@/views/widgets/DateTimeWidget.vue'
import {
  BLink, BNavbarNav,
} from 'bootstrap-vue'
import Bookmarks from './components/Bookmarks.vue'
import Locale from './components/Locale.vue'
import SearchBar from './components/SearchBar.vue'
import DarkToggler from './components/DarkToggler.vue'
import CartDropdown from './components/CartDropdown.vue'
import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from './components/UserDropdown.vue'
import { OrbitSpinner } from 'epic-spinners'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BLink,
    OrbitSpinner,

    // Navbar Components

    BNavbarNav,
    Bookmarks,
    Locale,
    SearchBar,
    DarkToggler,
    CartDropdown,
    NotificationDropdown,
    UserDropdown,
    DateTimeWidget
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },

  setup() {
    const spinner = ref(false)
    return {
      spinner
    }
  }
}
</script>
